import type { ErrorResponse } from '@/types/client.types';
import { postPresignedUrlImg } from '@/apis/img';
import { useLoadingStore } from '@/store/loading';
import axios, { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { validateAndFixImageFile } from './detectImageFormat';

const { setLoading, beginRequest, endRequest } = useLoadingStore.getState();

const uploadToS3 = async (url: string, file: File) => {
  await axios({
    method: 'put',
    url: url,
    data: file,
    timeout: 120000,
  });
};

const uploadImagePresignedUrl = async (imgList: FileList | null) => {
  try {
    beginRequest();
    if (imgList && imgList.length > 0) {
      const file = imgList[0];

      // ⚠️ VALIDATE & FIX
      const validationResult = await validateAndFixImageFile(file);

      if (!validationResult.isValid) {
        toast.error(
          validationResult.error || '이미지 파일만 업로드 가능합니다.',
          {
            autoClose: 5000,
          }
        );
        endRequest();
        setLoading(false);
        return;
      }

      const fixedName = validationResult.fixedName;

      const { data } = await postPresignedUrlImg({ files: [fixedName] });
      const url = data[0];

      await uploadToS3(url, file); // Vẫn upload file gốc
      return url.split('?')[0];
    }
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const axiosError: AxiosError<ErrorResponse> = error;
      toast.error(axiosError.response?.data.message);
    } else {
      console.log(error);
    }
  } finally {
    endRequest();
    setLoading(false);
  }
};

export default uploadImagePresignedUrl;
